import React from 'react'
import Header from '../../shared/header';
import Footer from '../../shared/footer';
import AboutLogo from "../../assets/images/about/Frame 70.svg"

const AboutBanner = () => {
    return (
        <div className='about-banner-img'>
            <div className='header-footer-main-div'>
                <Header />
                {/* main-logo-about */}
                <div className='container'>
                    <div className='main-logo-about'>
                        <img src={AboutLogo} alt='AboutLogo' />
                    </div>
                </div>
                <Footer hideRadioButtons={true} ContentHideAbout={true} />
            </div>
        </div>
    )
}

export default AboutBanner;